import React from 'react'

const SkipNavigation: React.FC = () => {
  return (
    <div className="u_skip">
      <a href="#content" className="blind">
        본문 바로가기
      </a>
    </div>
  )
}

export default SkipNavigation
